import { DataLayer, DataLayerEntry } from '@/types';

/**
 * Name event with step name to fire it after said step was filled
 */
export const analyticsEvents: { [key: string]: DataLayer } = {
    personalDataConfirm: {
        event: 'GAEvent',
        eventCategory: 'Onboarding',
        eventAction: 'Dane_osobowe',
        eventLabel: 'Zapisane',
        eventValue: 0,
        eventNonInteraction: true,
    },
};

export const staticDataLayers = {
    start: [
        {
            event: 'lead',
            pageName: 'TMS_PL_New_Onboarding_data_upload_choice',
            userId: '{{userId}}',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: '{{leadId}}',
                        revenue: '0.0',
                        tax: '0.0',
                        shipping: '0.0',
                    },
                    products: [
                        {
                            name: 'Lead - TMS_{{language}}_Real_New_Onboarding - start',
                            id: '{{leadId}}' + '-1',
                            brand: 'TMS_{{language}}_App',
                            category: 'Lead',
                            quantity: 1,
                        },
                    ],
                },
            },
        },
        {
            event: 'mailLogin',
            eventCategory: 'MailForm',
            eventLabel: 'Rejestracja konta real',
            eventAction: 'Rejestracja',
            userId: '{{userId}}',
        },
    ],
};

export const dataLayers: DataLayerEntry[] = [
    {
        routeName: 'errorsReport',
        dataLayer: [
            {
                event: 'real_form_completed',
                userId: '{{userId}}',
                ecommerce: {
                    purchase: {
                        actionField: {
                            id: '{{leadId}}',
                            revenue: 0.0,
                            tax: 0.0,
                            shipping: 0.0,
                        },
                        products: [
                            {
                                name: 'real_form_completed',
                                id: '{{leadId}}-1',
                                brand: 'TMS_{{language}}',
                                category: 'Real',
                                quantity: 1,
                            },
                        ],
                    },
                },
            },
        ],
    },
];

export const gtmTags: { [key: string]: string } = {
    PL: 'GTM-QZT3Z',
    EN: 'GTM-KG4QDF',
    LT: 'GTM-K8K43Q',
    LV: 'GTM-NZMBCK',
    ES: 'GTM-5QH3VNK',
    RU: 'GTM-NZMBCK',
    CZ: 'GTM-KL93Z4W',
    UA: 'GTM-KPMGCB2',
    OANDA: 'GTM-TLC257H',
};
